import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import TagsBar from '../../common/tags-bar';
import Buff from '../../common/buff';
import Level from '../../common/level';
import articleTagsService from '../../../services/article-tags/article-tags';
import Button from '../../common/button/button';

import './article-summary.css';

const readMoreButtonStyles = {
  button: {
    backgroundColor: 'rgba(43, 104, 156, 1)',
    border: 'solid rgba(43, 104, 156, 1) 0px'
  },
  label: {
    textTransform: 'capitalize'
  }
};

class ArticleSummary extends Component {
  render() {
    const relevantTags = articleTagsService.getRelevantRecommendationsTags(this.props.tags);

    const paragraphs = this.props.summary.map((paragraph, i) =>
      <p key={i}>{paragraph}</p>
    );

    const imgSrc = `/images/articles/${this.props._id}/summary.png`;
    const link = `/articles/${this.props.linkId}`;

    return (
      <summary className='article-summary'>
        <Link to={link}>
          <div className='article-image-container'>
            <div className='image-and-buff'>
              <img 
                src={imgSrc} 
                alt={this.props.title}
                title={this.props.title} />

              { this.props.buffText ? <Buff text={this.props.buffText} /> : '' }
            </div>
          </div>
        </Link>

        <div className='article-textual-details'>
          <Link to={link}>
            <h4>{this.props.title}</h4>
          </Link>  

          {/* <div className='date'>{this.props.date}</div> */}
          <div className='read-minutes'>{this.props.readMinutes} minutes</div>

          <div className='tags-container'>
            <TagsBar tags={relevantTags} />
          </div>

          <div className='level-container'>
            <Level level={this.props.level} />
          </div>          

          <div className='paragraphs'>
            {paragraphs}
          </div>

          <div className='button-container little-grow-animation'>
            <Link to={link}>          
              <Button label="Read More" isDark={ true } />
            </Link>
          </div>
        </div>
      </summary>
    );
  }
}

ArticleSummary.propTypes = {
  _id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  readMinutes: PropTypes.number.isRequired,
  summary: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  linkId: PropTypes.string.isRequired,
  nextLinkId: PropTypes.string,
  prevLinkId: PropTypes.string,
  buffText: PropTypes.string
};

export default ArticleSummary;